import React from 'react';
import { Box, styled } from '@mui/material';
import { getPaqueteriaImg } from '../../../../utils/getPaquteriaImg';

// eslint-disable-next-line consistent-return
const getSize = (size) => {
  if (size === 'small') {
    return '40px';
  }
  if (size === 'normal') {
    return '60px';
  }
  if (size === 'tiny') {
    return '30px';
  }
};

const BoxImg = styled(Box)(({ img = '', size = 'normal' }) => ({
  background: `url(${img})`,
  width: getSize(size),
  height: getSize(size),
  borderRadius: '50%',
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}));

function PaqueteriaAvatar({ rate_provider = '', size = 'normal' }) {
  const img = getPaqueteriaImg(rate_provider);

  // console.log(img);
  return <BoxImg img={img} size={size} />;
}

export default PaqueteriaAvatar;
